import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React from "react";
import { THEME_COLORS, FONT_FAMILY } from "@common/themes";
import { withOpacity } from "@common/helper";

export type TabSwitchItem = { label: string; value: any };

export type TabSwitchProps = {
  items: Array<TabSwitchItem>;
  value: TabSwitchItem;
  onSelect: (item: TabSwitchItem) => void;
  /**
   * @default compact
   */
  size?: "compact" | "normal";
};

const TabSwitchComponent = ({ items, value, onSelect, size = "normal" }: TabSwitchProps) => {
  const checkSelected = (item: TabSwitchItem) =>
    item === value || item?.value === value?.value;

  return (
    <View style={styles.container}>
      {items.map((it) => {
        const isSelected = checkSelected(it);

        return (
          <TouchableOpacity
            key={it.label}
            activeOpacity={0.8}
            onPress={() => onSelect?.(it)}
            style={[styles.tab, size === "compact" && styles.tabCompact, isSelected && styles.selectedTab]}
          >
            <Text
              style={[
                styles.tabLabel,
                size === "compact" && styles.tabLabelCompact,
                isSelected && styles.selectedTabLabel,
              ]}
            >
              {it.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default TabSwitchComponent;

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: withOpacity(THEME_COLORS.purple, 0.2),
    backgroundColor: THEME_COLORS.white,
    flexDirection: "row",
    overflow: "hidden",
    alignItems: "stretch",
  },

  tab: {
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderRadius: 7,
  },

  tabCompact: {
    paddingHorizontal: 24,
    paddingVertical: 12,
  },

  selectedTab: {
    backgroundColor: THEME_COLORS.lightPurple,
  },

  tabLabel: {
    color: THEME_COLORS.coal,
    fontFamily: FONT_FAMILY.primaryV3,
    fontSize: 13,
  },

  tabLabelCompact: {
    color: THEME_COLORS.coal,
    fontFamily: FONT_FAMILY.primaryV3,
    fontSize: 12,
  },

  selectedTabLabel: {
    color: THEME_COLORS.purple,
    fontFamily: FONT_FAMILY.mediumV3,
  },
});
